import { useCallback } from "react";
import { useStore } from "react-redux";
import type { RootState } from "../../redux/app/store";
import {
  QuoteStore,
  settleLoyaltyQuote,
} from "../../redux/utils/settleLoyaltyQuote";

/** Returns `settleLoyaltyQuote` bound to the app store. */
export function useSettledLoyaltyQuote(): (
  settled?: RootState
) => Promise<RootState | null> {
  const store = useStore<RootState>();

  return useCallback(
    (settled?: RootState) =>
      settleLoyaltyQuote(store as unknown as QuoteStore, { settled }),
    [store]
  );
}
